import { createAction } from 'redux-actions';
import types from '../types';

export const start5SecCycles = createAction(types.CYCLES_5_SEC);
export const start20SecCycles = createAction(types.CYCLES_20_SEC);
export const getConfig = createAction(types.GET_CONFIG_REQUESTED);
export const getConfigSucceeded = createAction(types.GET_CONFIG_SUCCEEDED);
export const getConfigFailed = createAction(types.GET_CONFIG_FAILED);
